export function hasZipCodeTaxError(_ref) {
  let {
    calculationErrors
  } = _ref;
  return calculationErrors?.taxCalculationError?.validationError?.fieldViolations?.some(violationObject => violationObject.field === 'postalCode' && violationObject.description === 'MISSING') ?? false;
}
export function hasSubdivisionTaxError(_ref2) {
  let {
    calculationErrors
  } = _ref2;
  return calculationErrors?.taxCalculationError?.validationError?.fieldViolations?.some(violationObject => violationObject.field === 'subdivision' && violationObject.description === 'MISSING') ?? false;
}
export function hasSubdivisionShippingError(_ref3) {
  let {
    calculationErrors
  } = _ref3;
  return calculationErrors?.carrierErrors?.errors?.some(_ref4 => {
    let {
      error
    } = _ref4;
    return error?.validationError?.fieldViolations?.some(_ref5 => {
      let {
        field
      } = _ref5;
      return field === 'shippingDestination.subdivision' || field === 'shippingDestination';
    });
  }) ?? false;
}
export function hasZipCodeShippingError(_ref6) {
  let {
    calculationErrors
  } = _ref6;
  return calculationErrors?.carrierErrors?.errors?.some(_ref7 => {
    let {
      error
    } = _ref7;
    return error?.validationError?.fieldViolations?.some(_ref8 => {
      let {
        field
      } = _ref8;
      return field === 'postalCode';
    });
  }) ?? false;
}
//# sourceMappingURL=calculationError.utils.js.map